<header class="header">
  <div class="logo"></div>
  <p>{{ "LOGIN.HEADER_TITLE" | translate }}</p>
</header>
<main class="main" aria-live="polite">
  @if (isAuthenticated()) {
    <section class="form">
      @if (tenants().length) {
        <p-select
          [disabled]="isLoading()"
          [options]="tenants()"
          [placeholder]="'LOGIN_TENANT.SELECT_TENANT' | translate"
          [(ngModel)]="selectedTenant"
          [attr.data-qa]="'login-tenant-dropdown'"
          scrollHeight="400px"
        >
          <ng-template #item let-item>
            <div [attr.data-qa]="'login-tenant-item-' + item.id">{{ item.name }}</div>
          </ng-template>
          <ng-template #selectedItem let-item>
            <div [attr.data-qa]="'login-tenant-selected-item'">{{ item.name }}</div>
          </ng-template>
        </p-select>
        <p-button
          [disabled]="!selectedTenant() || isLoading()"
          [attr.data-qa]="'login-tenant-continue'"
          (onClick)="onLoginClick()"
        >
          <p>{{ "COMMON.CONTINUE" | translate }}</p>
          @if (isLoading()) {
            <p-progress-spinner />
          } @else {
            <fl-icon name="pi-chevron-right" />
          }
        </p-button>
        <p class="version">{{ "LOGIN.VERSION" | translate: { version: version() } }}</p>
      } @else {
        <p>{{ "LOGIN_TENANT.NO_TENANT" | translate }}</p>
        <p-button [attr.data-qa]="'login-tenant-logout'" (onClick)="logout.emit()">
          <p>{{ "TOP_MENU.SIGN_OUT" | translate }}</p>
          <fl-icon name="logout" />
        </p-button>
      }
    </section>
  }
</main>
<footer class="footer"></footer>
